module.exports = __webpack_public_path__ + "img/GP1.Croatia_CityCircle.3f7dd692.jpg";